import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Subject, Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import { Audit, NextAudit } from '../interfaces/audit.interface';
import { map, pluck } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CommonService {
  private readonly url: string = environment.url;
  private moduleSource = new Subject<string>();

  currentModule = this.moduleSource.asObservable();

  constructor(private http: HttpClient) {}

  getCompanyList(): Observable<any> {
    return this.http.get<any>(`${this.url}/api/get/companies/list`).pipe(pluck('companies'));
  }

  getAuthorList(
    company: string,
    date_in: Date,
    date_out: Date
  ): Observable<any> {
    return this.http.post<any>(`${this.url}/api/get/authors/list`, {
      company,
      date_in,
      date_out,
    });
  }

  makeStatistics(): Observable<any> {
    return this.http.get<any>(`${this.url}/api/upsert/audit/statistics`);
  }

  // loading audit candidate and setting the state token for any events
  loadNextAudit(
    authorsList,
    company,
    product,
    date_in,
    date_out,
    analisis
  ): Observable<any> {
    return this.http.post<any>(`${this.url}/api/audit/next`, {
      authorsList,
      company,
      product,
      date_in,
      date_out,
      analisis,
    }).pipe(
      map((res) => {
        sessionStorage.setItem('state', res.token);
        return ({
          info: res.data,
          documents: this.setNewState(res.data),
        });
      }),
    );
  }

  getCurrentAudit(): Observable<any> {
    return this.http.get<any>(`${this.url}/api/audit/current`).pipe(
      map((res) => ({
        info: res.data,
        documents: this.setNewState(res.data),
      }))
    )
  }

  getAuditResults(): Observable<any> {
    return this.http.get<any>(`${this.url}/api/audit/results`);
  }

  updateModuleSource(module: string): void {
    this.moduleSource.next(module);
  }

  private setNewState(data) {
    let listDocuments: string[] = data.events.analysis_module.documents.list;
    const events = data?.events;
    if (events?.esocial_module) {
      listDocuments = [...listDocuments, 'esocial_module'];
    }
    return Object.keys(events)
      .filter((key) => listDocuments.includes(key))
      .reduce((all, item) => {
        if (item === 'esocial_module') {
          // document = this.checkStatusDocument(doc);
          return { ...all, [item]: this.setEsocialData(events) };
        }

        const doc = {
          ...events[item],
          selected: false,
          key: item,
          fields: {
            ...events[item].fields,
            data: this.mountData(events, events[item].fields.list),
          },
          images: {
            ...events[item].images,
            data: this.mountData(events, events[item].images.list),
          },
        };

        // document = this.checkStatusDocument(doc);
        return { ...all, [item]: doc };
      }, {});
  }

  private setEsocialData(events, key = 'esocial_module'): any {
    const fields = events[key].fields.reduce((acc, item) => {
      acc = [...acc, {...item, value: events[item.reference].value}];
      return acc;
    }, []);

    return {
      fields,
      reasons: events[key]?.reasons,
      key: key,
      step: 'esocial',
      slug: 'esocial',
      icon: events[key].status,
      status: events[key].status
    }
  }

  private mountData(evs, arr: Array<string>): Array<any> {
    return Object.keys(evs)
      .filter((datakey) => arr.includes(datakey))
      .map((item) => ({ ...evs[item], key: item }));
  }
}
